import React from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

//store functions
import {initMoving, resetState, redirectToLogin, goToPage, getProducts, setContactDetails} from './MovingBlockSlice';

// Pages Imports
import AddressPage from './Pages/AddressPage';
import ProductsPage from './Pages/ProductsPage';
import TechnicianPage from './Pages/TechnicianPage';
import SummaryPage from './Pages/SummaryPage';
import ErrorPage from './Pages/ErrorPage';
import TruckAnimationPage from './Pages/TruckAnimationPage';
import CompletePage from './Pages/CompletePage';
import ServiceMessagesPage from './Pages/ServiceMessagesPage';
import PackagesPage from './Pages/PackagesPage';

const Moving = (props) => {
  let currentView = null;

  useExtendedEffect((runSideEffects) => {
    props.initMoving({movingEpiData: props.iContent});
    props.setContactDetails({
      firstName: props.userDetails.firstName,
      lastName: props.userDetails.lastName,
      phone: props.userDetails.contactNumber,
    });
    props.getProducts();
    return () => {
      props.resetState();
    };
  }, []);

  useClearStateResetFlag();

  switch (props.page) {
    case 'addressPage':
      currentView = <AddressPage />;
      break;
    case 'productsPage':
      currentView = <ProductsPage />;
      break;
    case 'technicianPage':
      currentView = <TechnicianPage />;
      break;
    case 'summaryPage':
      currentView = <SummaryPage context={props.context} />;
      break;
    case 'errorPage':
      currentView = <ErrorPage context={props.context} />;
      break;
    case 'truckAnimationPage':
      currentView = <TruckAnimationPage />;
      break;
    case 'completePage':
      currentView = <CompletePage />;
      break;
    case 'serviceMessagesPage':
      currentView = <ServiceMessagesPage context={props.context} />;
      break;
    case 'packagesPage':
      currentView = <PackagesPage context={props.context} />;
      break;
  }

  return <>{currentView}</>;
};

const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    loginData: state.authentication.loginData,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    userDetails: state.authentication.loginData.userDetails,
  };
};

const mapDispatchToProps = {
  initMoving,
  resetState,
  redirectToLogin,
  goToPage,
  getProducts,
  showAppLoader,
  hideAppLoader,
  setContactDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(Moving);
